import { FC } from 'react';
import { SvgProps } from './domain';

const Calendar: FC<SvgProps> = ({ className }) => {
  return (
    <svg
      className={className}
      viewBox='0 0 30 30'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M11.25 1.25V3.75H18.75V1.25H21.25V3.75H26.25C26.9404 3.75 27.5 4.30965 27.5 5V25C27.5 25.6904 26.9404 26.25 26.25 26.25H3.75C3.05965 26.25 2.5 25.6904 2.5 25V5C2.5 4.30965 3.05965 3.75 3.75 3.75H8.75V1.25H11.25ZM25 13.75H5V23.75H25V13.75ZM10 16.25V18.75H7.5V16.25H10ZM16.25 16.25V18.75H13.75V16.25H16.25ZM22.5 16.25V18.75H20V16.25H22.5ZM8.75 6.25H5V11.25H25V6.25H21.25V8.75H18.75V6.25H11.25V8.75H8.75V6.25Z'
        fill='url(#paint0_linear_1796_461)'
      />
      <circle cx='9' cy='17.25' r='1.5' fill='url(#paint1_linear_1796_461)' />
      <circle cx='15' cy='17.25' r='1.5' fill='url(#paint2_linear_1796_461)' />
      <circle cx='21' cy='17.25' r='1.5' fill='url(#paint3_linear_1796_461)' />
      <defs>
        <linearGradient
          id='paint0_linear_1796_461'
          x1='15'
          y1='1.25'
          x2='15'
          y2='26.25'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#006FFF' />
          <stop offset='1' stopColor='#00D2A4' />
        </linearGradient>
        <linearGradient
          id='paint1_linear_1796_461'
          x1='9'
          y1='15.75'
          x2='9'
          y2='18.75'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#006FFF' />
          <stop offset='1' stopColor='#00D2A4' />
        </linearGradient>
        <linearGradient
          id='paint2_linear_1796_461'
          x1='15'
          y1='15.75'
          x2='15'
          y2='18.75'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#006FFF' />
          <stop offset='1' stopColor='#00D2A4' />
        </linearGradient>
        <linearGradient
          id='paint3_linear_1796_461'
          x1='21'
          y1='15.75'
          x2='21'
          y2='18.75'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#006FFF' />
          <stop offset='1' stopColor='#00D2A4' />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default Calendar;
